import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue'
import ProfileEventRow from '@/pages/ProfilePage/ui/ProfileEventRow.vue'
import { eventApi, EventDB, EventPeriod } from '@/enitites/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileEventList',
  props: {
    tab: null,
    userId: null,
    withPagination: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  tab: EventPeriod
  userId: number
  withPagination?: boolean
};



const events = ref<EventDB[]>([])
const searchParams = ref({
  pageNumber: 0,
  pageSize: props.withPagination ? 5 : 100,
  userId: props.userId,
  tab: props.tab,
})

const infiniteId = ref(+new Date())

async function fetchEvents() {
  const data = await eventApi.getEvents(searchParams.value)
  if (!data || typeof data === 'string') return
  events.value = data
  searchParams.value.pageNumber += 1
}

async function infiniteHandler($state: { complete: () => void; loaded: () => void }) {
  const data = await eventApi.getEvents(searchParams.value)
  if (!data || typeof data === 'string') return
  searchParams.value.pageNumber += 1
  events.value = [...events.value, ...data]
  if (data.length < searchParams.value.pageSize) $state.complete()
  else $state.loaded()
}

function resetLoading() {
  searchParams.value = {
    pageNumber: 0,
    pageSize: props.withPagination ? 5 : 100,
    userId: props.userId,
    tab: props.tab,
  }
  events.value = []
  infiniteId.value = +new Date() + Math.random()
  fetchEvents()
}

watch(() => props.userId, resetLoading)
watch(() => props.tab, resetLoading)

onMounted(async () => {
  await fetchEvents()
})

return { __sfc: true,props, events, searchParams, infiniteId, fetchEvents, infiniteHandler, resetLoading, ProfileEventRow }
}

})